import React, { useMemo, useState, useCallback } from "react";
import { Col, Row } from "react-bootstrap";
import RejectRemarkForm from "./RejectRemarkForm";
import DatePicker from "react-datepicker";
import moment from "../../../util/momentTimezone";

import styles from './ApprovalContent.module.css';

import { localTimeToPickerTime, pickerTimeTolocalTime } from "../../../util/momentTimezone";
import Noti from "../../../util/noti";

const ApprovalContent = (props) => {
	const isSolo = props.selectedSite.solo;
	const updateInvoiceStatus = props.updateInvoiceStatus;
	const process = props.process;
	const showVatInvoiceForm = props.showVatInvoiceForm;

	const maxDate = useMemo(() => new Date(), []);
	const [vatInvoiceDate, setVatInvoiceDate] = useState(moment(maxDate));
	const [vatInvoiceNumber, setVatInvoiceNumber] = useState('');

	const validateVatInvoiceForm = useCallback(() => {
		const result = {};
		if(!vatInvoiceDate) { result.error = true; result.msg = 'Invoice Date cannot be empty' }
		if(!vatInvoiceNumber.trim() || !/^\d+$/gi.test(vatInvoiceNumber.trim())) { result.error = true; result.msg = 'Invoice Number can only be "Number". Please make sure you don\'t have characters or symbols in VAT invoice number' }
		if(!/^\d{0,8}$/gi.test(vatInvoiceNumber.trim())) { result.error = true; result.msg = 'Invoice Number length cannot be greater 8' }
		return result;
	}, [ vatInvoiceDate, vatInvoiceNumber ]);

	const handleUpdateInvoiceStatus = useCallback(() => {
		if(showVatInvoiceForm) { // for VN invoice and approval status === 2 only
			const invoiceValidation = validateVatInvoiceForm();
			if(invoiceValidation.error) {
				return Noti.create({
					type: "e",
          msg: "Please enter valid invoice data",
					title: invoiceValidation.msg
				});
			}
			const vatInvoiceVN = {
				vat_inv_no: vatInvoiceNumber.trim(),
				vat_inv_date: vatInvoiceDate.format('YYYY-MM-DD'),
			};
			updateInvoiceStatus(process, null, vatInvoiceVN);
		} else {
			updateInvoiceStatus(process, null);
		}
	}, [showVatInvoiceForm, vatInvoiceNumber, vatInvoiceDate, updateInvoiceStatus, process, validateVatInvoiceForm]);

	return (
		<div className="form-contents">
			<Row>
				<Col md="10">
					<h5>
						{props.process}{" "}
						<strong>
							{!isSolo && props.selectedSite.value.company}{" "}
							{props.selectedSite.label}
						</strong>
						's invoice?
					</h5>
				</Col>
				<Col md="2">
					<span
						onClick={() => {
							props.closeForm();
						}}
						style={{ float: "right", cursor: "pointer" }}
						className="glyphicon glyphicon-remove close-approval"
					></span>
				</Col>
			</Row>
			{props.process === "REJECT" && (
				<RejectRemarkForm
					selectedSite={props.selectedSite}
					updateInvoiceStatus={props.updateInvoiceStatus}
					closeForm={props.closeForm}
				/>
			)}
			{(props.process === "APPROVE" || props.process === "RESOLVE") && (
				<div>
					{showVatInvoiceForm && <div className={styles.vatInvoiceForm}>
						<Row >
							<Col md="4">
								<strong>VAT Invoice Date:</strong>
							</Col>
							<Col md="8">
								<DatePicker
									maxDate={localTimeToPickerTime(maxDate)}
									selected={localTimeToPickerTime(vatInvoiceDate.toDate())}
									onChange={(date) => {
										const selectedDate = moment(pickerTimeTolocalTime(date));
										setVatInvoiceDate(selectedDate);
									}}
								/>
							</Col>
						</Row>
						<Row>
							<Col md="4">
								<strong>VAT Invoice Number:</strong>
							</Col>
							<Col md="8">
								<input type="text" value={vatInvoiceNumber} onChange={e => setVatInvoiceNumber(e.target.value)} />
							</Col>
						</Row>
					</div>}
					<div className="btn-container">
						<button
							className="btn btn-primary btn-generate btn-approval"
							title="Confirm"
							onClick={handleUpdateInvoiceStatus}
						>
							<span>Confirm</span>
						</button>
					</div>
				</div>
			)}
		</div>
	);
};

export default ApprovalContent;
